export default __webpack_public_path__ + "static/media/CoronavirusComeFrom.2894d04f.svg";